import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { showModal } from "../statusModal/statusModal";
import { createAppVersionAPI, fetchLatestAppVersionAPI } from "./appVersionAPI";

export const fetchLatestAppVersion = createAsyncThunk(
  "appVersion/fetchLatest",
  async (platform, { rejectWithValue }) => {
    try {
      const version = await fetchLatestAppVersionAPI(platform);
      return { platform, version };
    } catch (err) {
      return rejectWithValue({
        platform,
        error: err.response?.data?.message || "Fetch failed",
      });
    }
  }
);

export const createAppVersion = createAsyncThunk(
  "appVersion/create",
  async (payload, { dispatch, rejectWithValue }) => {
    const platformName = payload.platform === "ios" ? "iOS" : "Android";
    try {
      const version = await createAppVersionAPI(payload);
      dispatch(
        showModal({
          message: `تم حفظ إصدار تطبيق ${platformName} بنجاح`,
          status: "success",
        }),
      );
      return { platform: payload.platform, version };
    } catch (err) {
      dispatch(
        showModal({
          message: `حصل خطأ اثناء حفظ إصدار تطبيق ${platformName}`,
          status: "error",
        }),
      );
      return rejectWithValue({
        platform: payload.platform,
        error: err.response?.data?.message || "Creation failed",
      });
    }
  }
);

const initialState = {
  android: {
    version: null,
    status: "idle",
    error: null,
  },
  ios: {
    version: null,
    status: "idle",
    error: null,
  },
  createStatus: "idle",
  createError: null,
};

const appVersionSlice = createSlice({
  name: "appVersion",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestAppVersion.pending, (state, action) => {
        const platform = action.meta.arg;
        state[platform].status = "loading";
        state[platform].error = null;
      })
      .addCase(fetchLatestAppVersion.fulfilled, (state, action) => {
        const { platform, version } = action.payload;
        state[platform].status = "succeeded";
        state[platform].version = version.latestVersion;
      })
      .addCase(fetchLatestAppVersion.rejected, (state, action) => {
        const { platform, error } = action.payload;
        state[platform].status = "failed";
        state[platform].error = error;
      })

      .addCase(createAppVersion.pending, (state) => {
        state.createStatus = "loading";
        state.createError = null;
      })
      .addCase(createAppVersion.fulfilled, (state, action) => {
        const { platform, version } = action.payload;
        state.createStatus = "succeeded";
        state[platform].version = version.latestVersion;
      })
      .addCase(createAppVersion.rejected, (state, action) => {
        state.createStatus = "failed";
        state.createError = action.payload.error;
      });
  },
});

export default appVersionSlice.reducer;
